"use client"

import { useEffect, useRef, useState } from "react"
import JSZip from "jszip"
import { Col, Modal, ModalBody, ModalFooter, ModalHeader, Row } from "reactstrap"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import {
  faBullhorn,
  faChartLine,
  faCheckCircle,
  faCheckDouble,
  faCoins,
  faDeleteRight,
  faEdit,
  faFileCertificate,
  faList,
  faListDropdown,
  faPlus,
  faSave,
  faSend,
  faShieldCheck,
  faShieldXmark,
  faStars,
  faSuitcase,
  faTrash,
  faUserGroup,
} from "@fortawesome/pro-duotone-svg-icons"
import { useNavigate } from "react-router-dom"
// import { advanceSearch } from "../../../../../_helper/services/advanceSearchv2"
import {
  faArrowTrendUp,
  faCertificate,
  faCircle,
  faDollarSign,
  faDownload,
  faEye,
  faFolderOpen,
  faSearch,
  faSignature,
} from "@fortawesome/free-solid-svg-icons"
import {
  Button,
  TextField,
  Card,
  CardContent,
  Typography,
  Chip,
  Grid,
  CardHeader,
  Skeleton,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Pagination,
  TableContainer,
  Paper,
  Table,
  TableRow,
  TableCell,
  TableHead,
  TableBody,
  Autocomplete,
  Box,
  CircularProgress,
  List,
  ListItem,
  IconButton,
  ListItemText,
  Checkbox,
  FormControlLabel,
} from "@mui/material"
import { getUserId, getUserRole, ShowError, ShowSucess } from "../../../_helper/helper"
import { get, post, put, remove } from "../../../_helper/api_helper"
import { getFormalApiErrorMessage } from "../../../utils/apiError"
import { useAuth } from "oidc-react"
import { useDispatch, useSelector } from "react-redux"
// import CountdownProgressBar from "./CountdownProgressBar"
// import CertificationCharts from "../../CertificationReport/CertificationCharts";
import { advanceSearch } from "../../../_helper/services/advanceSearchv2"
import CountdownProgressBar from "../Components/CertificateWork/Components/CountdownProgressBar"
import CertificationCharts from "../Components/CertificationReport/CertificationCharts"
import ApplicationPdfPage from "../Components/CertificateWork/Components/ApplicationPdfPage"

const ViewCertification = ({ annId, gaId, certPid, callUpdateStep }) => {
  const dispatch = useDispatch()
  const [cdata, setCdata] = useState([])
  const [searchTerm, setSearchTerm] = useState("")
  const [filteredCertifications, setFilteredCertifications] = useState([])
  const [loading, setLoading] = useState(true)
  const [currentPage, setCurrentPage] = useState(1)
  const [itemsPerPage, setItemsPerPage] = useState(10)
  const [error, setError] = useState(null)
  const [showPdf, setShowPdf] = useState(false)
  const [AgencyDirectors, setAgencyDirectors] = useState([])
  const [EeoRepresentative, setEeoRepresentative] = useState([])
  const [PersonalOfficer, setPersonalOfficer] = useState([])
  const [Poc, setPoc] = useState([])
  const [selectedAgencyDirector, setSelectedAgencyDirector] = useState(null)
  const [selectedEEORepresentative, setSelectedEEORepresentative] = useState(null)
  const [selectedPersonalOfficer, setSelectedPersonalOfficer] = useState(null)
  const [selectedDepartmentContact, setSelectedDepartmentContact] = useState(null)
  const [selectedCertification, setSelectedCertification] = useState({ CERTIFICATION_PID: certPid, ANNOUNCEMENT_ID: annId })
  const baseURL = process.env.REACT_APP_API_DOTNET_URL
  const { userData } = useAuth()
  const [modal, setModal] = useState(false)
  // const [combinedPanelistModalOpen, setCombinedPanelistModalOpen] = useState(false)
  const { employee } = useSelector((state) => state.employeeReducer)
  const Role = getUserRole(userData)
  const [showCharts, setShowCharts] = useState(false)

  // Panelist assignment (part of the Assign AD/EEO/PO/POC modal)
  const DUMMY_PANELISTS = [
    { ID: -1, EmployeeName_LFM: "Doe, John", Position: "HR Analyst", PayGrade: "GG-9" },
    { ID: -2, EmployeeName_LFM: "Smith, Jane", Position: "Program Manager", PayGrade: "GG-13" },
    { ID: -3, EmployeeName_LFM: "Brown, Michael", Position: "IT Specialist", PayGrade: "GG-11" },
    { ID: -4, EmployeeName_LFM: "Davis, Emily", Position: "Budget Analyst", PayGrade: "GG-12" },
    { ID: -5, EmployeeName_LFM: "Wilson, David", Position: "Contract Specialist", PayGrade: "GG-11" },
    { ID: -6, EmployeeName_LFM: "Taylor, Sarah", Position: "HR Specialist", PayGrade: "GG-9" },
    { ID: -7, EmployeeName_LFM: "Anderson, Robert", Position: "Operations Manager", PayGrade: "GG-14" },
    { ID: -8, EmployeeName_LFM: "Thomas, Laura", Position: "Administrative Officer", PayGrade: "GG-7" },
    { ID: -9, EmployeeName_LFM: "Jackson, Chris", Position: "Financial Analyst", PayGrade: "GG-12" },
    { ID: -10, EmployeeName_LFM: "White, Amanda", Position: "Compliance Officer", PayGrade: "GG-13" },
  ]
  const [allEmployees, setAllEmployees] = useState(DUMMY_PANELISTS)
  const [selectedPanelists, setSelectedPanelists] = useState([])
  const [existingPanelists, setExistingPanelists] = useState([])
  const [currentCertForPanel, setCurrentCertForPanel] = useState(null)
  const [panelLoading, setPanelLoading] = useState(false)

  // Score Card Criteria Modal
  const [scoreCardModalOpen, setScoreCardModalOpen] = useState(false)
  const [currentCertForScoreCard, setCurrentCertForScoreCard] = useState(null)
  const [questions, setQuestions] = useState([])
  const [scoreCardLoading, setScoreCardLoading] = useState(false)
  const [newQuestion, setNewQuestion] = useState("")
  const [editingQuestion, setEditingQuestion] = useState(null)

  // Certificate Package Document List Modal
  const [documentListModalOpen, setDocumentListModalOpen] = useState(false)
  const [currentCertForDocumentList, setCurrentCertForDocumentList] = useState(null)
  const [certificateDocuments, setCertificateDocuments] = useState([])
  const [certificateDocumentsLoading, setCertificateDocumentsLoading] = useState(false)
  const [downloadAllDocumentsLoading, setDownloadAllDocumentsLoading] = useState(false)
  const [downloadingCertificateDocumentMap, setDownloadingCertificateDocumentMap] = useState({})
  // In-page preview (iframe modal) for a document picked from the list, instead
  // of opening it in a new tab.
  const [documentPreviewOpen, setDocumentPreviewOpen] = useState(false)
  const [documentPreviewUrl, setDocumentPreviewUrl] = useState(null)
  const [documentPreviewTitle, setDocumentPreviewTitle] = useState("")
  // Per-CERTIFICATION_PID: did every applicant already get a final StatusCode
  // and none of them is "SEL" (Selected)? A blank/pending StatusCode doesn't
  // count - it just means feedback hasn't come in yet. Same rule CertificatePrepare.jsx
  // uses for its "No Applicant Selected - Recertification Needed" warning.
  const [allNotSelectedByCert, setAllNotSelectedByCert] = useState({})
  // Per-CERTIFICATION_PID: applicants with StatusCode "SEL" for this cert --
  // shown as "Application - {name}" rows in the Completed Certification
  // Packet Documents modal below, same as CertificatePrepare.jsx.
  const [selectedApplicantsByCert, setSelectedApplicantsByCert] = useState({})
  // Applicant whose Application is being shown via ApplicationPdfPage, opened
  // from the Selected Applicant(s) rows inside the Completed Certification
  // Packet Documents modal - same pattern as CertificatePrepare.jsx.
  const [applicationPdfApplicant, setApplicationPdfApplicant] = useState(null)
  const applicationPdfPageRef = useRef(null)
  const [applicationPdfDownloading, setApplicationPdfDownloading] = useState(false)
  // Downloads an applicant's Application straight from the row (no need to
  // open the View Application modal first) via an off-screen ApplicationPdfPage
  // instance - it calls back through onReady once its content has actually
  // painted, which is the earliest point download() is safe to call.
  const [applicationDownloadTarget, setApplicationDownloadTarget] = useState(null)
  const applicationDownloadRef = useRef(null)
  const [downloadingApplicationKey, setDownloadingApplicationKey] = useState(null)
  // Guards against onReady firing more than once for the same off-screen
  // instance (e.g. an unrelated re-render higher up recreating the onReady
  // callback prop while the download is still in flight).
  const applicationDownloadInFlightRef = useRef(false)
  // Off-screen source for "Download All" to bundle each selected applicant's
  // Application PDF into the same zip as the other uploaded documents -- a
  // second, independent off-screen instance/ref from applicationDownloadTarget
  // above so a row-level "Download" click can't collide with an in-progress
  // "Download All" zip capture.
  const [zipCaptureTarget, setZipCaptureTarget] = useState(null)
  const zipCaptureRef = useRef(null)
  const zipCaptureResolveRef = useRef(null)
  const zipCaptureInFlightRef = useRef(false)

  const fetchApplicantSelectionStatus = async (cert) => {
    const params = [
      {
        columnName: "ANNOUNCEMENT_ID",
        value: cert.ANNOUNCEMENT_ID,
        operator: "=",
        dataType: "varchar(MAX)",
        logicOperator: "AND",
      },
      {
        columnName: "CERTIFICATION_PID",
        value: cert.CERTIFICATION_PID,
        operator: "=",
        dataType: "varchar(MAX)",
        logicOperator: "AND",
      },
    ]
    const payload = {
      tableName: "GET-CERTIFICATION-APP",
      searchParams: JSON.stringify(params),
      columns: "*",
      location: "pmis-global",
      pageNumber: 1,
      pageSize: 9999,
      sortData: "",
      additionalWhere: "",
      qID: 0,
    }
    try {
      const response = await advanceSearch(payload)
      const applicants = response.results || []
      const allNotSelected =
        applicants.length > 0 &&
        applicants.every((a) => Boolean(a.StatusCode)) &&
        applicants.every((a) => a.StatusCode !== "SEL")
      setAllNotSelectedByCert((prev) => ({
        ...prev,
        [cert.CERTIFICATION_PID]: allNotSelected,
      }))
      const selectedApplicants = applicants
        .filter((a) => a.StatusCode === "SEL")
        .map((a) => ({
          APPLICANT_NAME: a.APPLICANT_NAME,
          APPLICATION_ID: a.APPLICATION_ID,
          ANNOUNCEMENT_ID: a.ANNOUNCEMENT_ID,
        }))
      setSelectedApplicantsByCert((prev) => ({
        ...prev,
        [cert.CERTIFICATION_PID]: selectedApplicants,
      }))
    } catch (error) {
      console.error("Error checking applicant selection status:", error)
    }
  }

  // Renders the applicant's Application as an HTML page (ApplicationPdfPage)
  // instead of opening the server-generated PDF in an iframe.
  const handleViewApplicationDocument = (applicant) => {
    setApplicationPdfApplicant(applicant)
  }

  // Downloads an applicant's Application directly from the row by mounting
  // ApplicationPdfPage off-screen instead of requiring the View Application
  // modal to be open first.
  const handleDownloadApplication = (applicant) => {
    const key = applicant.APPLICATION_ID ?? applicant.APPLICANT_NAME
    if (downloadingApplicationKey) return
    applicationDownloadInFlightRef.current = false
    setDownloadingApplicationKey(key)
    setApplicationDownloadTarget(applicant)
  }

  const handleApplicationDownloadReady = async () => {
    if (applicationDownloadInFlightRef.current) return
    applicationDownloadInFlightRef.current = true
    try {
      await applicationDownloadRef.current?.download()
    } catch (error) {
      console.error("Error downloading application:", error)
      ShowError("We are unable to download the application at this time. Please try again shortly.")
    } finally {
      applicationDownloadInFlightRef.current = false
      setDownloadingApplicationKey(null)
      setApplicationDownloadTarget(null)
    }
  }

  // Renders one applicant's Application off-screen and resolves with its
  // generated PDF as a base64 data URI, instead of triggering a save --
  // used by handleDownloadAllCertificateDocuments to fold each selected
  // applicant's Application into the same zip as the other documents.
  const captureApplicationPdfBase64 = (applicant) =>
    new Promise((resolve) => {
      zipCaptureInFlightRef.current = false
      zipCaptureResolveRef.current = resolve
      setZipCaptureTarget(applicant)
    })

  const handleZipCaptureReady = async () => {
    if (zipCaptureInFlightRef.current) return
    zipCaptureInFlightRef.current = true
    try {
      const base64 = await zipCaptureRef.current?.getPdfBase64()
      zipCaptureResolveRef.current?.(base64)
    } catch (error) {
      console.error("Error generating application PDF for zip:", error)
      zipCaptureResolveRef.current?.(null)
    } finally {
      zipCaptureResolveRef.current = null
      zipCaptureInFlightRef.current = false
      setZipCaptureTarget(null)
    }
  }

  // jsPDF's output("datauristring") is "data:application/pdf;filename=...;base64,<data>" --
  // JSZip needs an actual Blob, not that data URI string.
  const pdfDataUriToBlob = (dataUri) => {
    const base64Marker = "base64,"
    const base64Index = dataUri?.indexOf(base64Marker) ?? -1
    if (base64Index === -1) return null
    const binary = atob(dataUri.slice(base64Index + base64Marker.length))
    const bytes = new Uint8Array(binary.length)
    for (let i = 0; i < binary.length; i += 1) {
      bytes[i] = binary.charCodeAt(i)
    }
    return new Blob([bytes], { type: "application/pdf" })
  }

  const handleViewDocument = (doc) => {
    setDocumentPreviewUrl(doc.DocumentURL)
    setDocumentPreviewTitle(doc.Remarks || doc.DocumentName || "Document")
    setDocumentPreviewOpen(true)
  }

  // A plain <a download> link is ignored by the browser for cross-origin
  // DocumentURLs (it just opens/previews the file instead of saving it), so
  // fetch the file as a blob and trigger the save from an object URL instead
  // -- same approach handleDownloadAllCertificateDocuments uses for the zip.
  const handleDownloadCertificateDocument = async (doc) => {
    const docKey = doc.ID ?? doc.DocumentURL
    setDownloadingCertificateDocumentMap((prev) => ({ ...prev, [docKey]: true }))
    try {
      const response = await fetch(doc.DocumentURL)
      if (!response.ok) throw new Error(`Failed to fetch ${doc.DocumentName || doc.Remarks}`)
      const blob = await response.blob()
      const blobUrl = URL.createObjectURL(blob)
      const link = document.createElement("a")
      link.href = blobUrl
      link.download = doc.DocumentName || doc.Remarks || "Document"
      document.body.appendChild(link)
      link.click()
      link.remove()
      URL.revokeObjectURL(blobUrl)
    } catch (error) {
      console.error("Error downloading document:", error)
      ShowError("We are unable to download this document at this time. Please try again shortly.")
    } finally {
      setDownloadingCertificateDocumentMap((prev) => ({ ...prev, [docKey]: false }))
    }
  }

  const handleCloseDocumentPreview = () => {
    setDocumentPreviewOpen(false)
    setDocumentPreviewUrl(null)
    setDocumentPreviewTitle("")
  }

  const fetchCertificateDocuments = async (cert) => {
    setCertificateDocumentsLoading(true)
    const params = [
      {
        columnName: "ReferenceID",
        value: cert.CERTIFICATION_PID,
        operator: "IN",
        dataType: "varchar(MAX)",
        logicOperator: "AND",
      },
    ]
    const payload = {
      tableName: "fn_getDocumentAttachmentByReference",
      searchParams: JSON.stringify(params),
      columns: "*",
      location: "global",
      pageNumber: 1,
      pageSize: 100,
      sortData: "",
      additionalWhere: "",
      qID: 0,
    }
    try {
      const response = await advanceSearch(payload)
      const documents = response.results || []
      setCertificateDocuments(documents.filter((doc) => doc.Remarks !== "Signed Document"))
    } catch (error) {
      console.error("Error fetching certificate documents:", error)
      ShowError(
        getFormalApiErrorMessage(
          error,
          "We are unable to load certificate documents at this time. Please try again shortly."
        )
      )
      setCertificateDocuments([])
    } finally {
      setCertificateDocumentsLoading(false)
    }
  }

  // Fetches every document in the modal and bundles them into a single zip
  // (rather than firing one browser download per file) so the user gets one
  // folder-like archive for the whole certification packet.
  const handleDownloadAllCertificateDocuments = async () => {
    setDownloadAllDocumentsLoading(true)
    try {
      const zip = new JSZip()
      const usedNames = new Set()

      await Promise.all(
        certificateDocuments.map(async (doc, index) => {
          const response = await fetch(doc.DocumentURL)
          if (!response.ok) throw new Error(`Failed to fetch ${doc.DocumentName || doc.Remarks}`)
          const blob = await response.blob()

          let fileName = doc.DocumentName || doc.Remarks || `Document-${index + 1}`
          while (usedNames.has(fileName)) {
            fileName = `${doc.Remarks || "Document"}-${index + 1}`
          }
          usedNames.add(fileName)

          zip.file(fileName, blob)
        })
      )

      // Application PDFs are generated one at a time (the off-screen
      // ApplicationPdfPage instance is reused sequentially for each
      // applicant), unlike the parallel document fetches above.
      const applicants = selectedApplicantsByCert[currentCertForDocumentList?.CERTIFICATION_PID] || []
      for (const [index, applicant] of applicants.entries()) {
        const base64 = await captureApplicationPdfBase64(applicant)
        const blob = base64 ? pdfDataUriToBlob(base64) : null
        if (!blob) continue

        let fileName = `Application-${applicant.APPLICANT_NAME || "Applicant"}.pdf`
        while (usedNames.has(fileName)) {
          fileName = `Application-${applicant.APPLICANT_NAME || "Applicant"}-${applicant.APPLICATION_ID || index}.pdf`
        }
        usedNames.add(fileName)
        zip.file(fileName, blob)
      }

      const zipBlob = await zip.generateAsync({ type: "blob" })
      const zipUrl = URL.createObjectURL(zipBlob)
      const link = document.createElement("a")
      link.href = zipUrl
      link.download = `${currentCertForDocumentList?.CERTIFICATION_PID || "Certification"}-Documents.zip`
      document.body.appendChild(link)
      link.click()
      link.remove()
      URL.revokeObjectURL(zipUrl)
    } catch (error) {
      console.error("Error downloading documents as zip:", error)
      ShowError("We are unable to download the documents at this time. Please try again shortly.")
    } finally {
      setDownloadAllDocumentsLoading(false)
    }
  }

  const toggleDocumentListModal = (certificationData = null) => {
    if (certificationData && !documentListModalOpen) {
      setCurrentCertForDocumentList(certificationData)
      setDocumentListModalOpen(true)
      fetchCertificateDocuments(certificationData)
    } else {
      setDocumentListModalOpen(false)
      if (!certificationData) {
        setCurrentCertForDocumentList(null)
        setCertificateDocuments([])
      }
    }
  }

  // Fixed toggle function to properly handle certification selection
  const toggle = (certificationData = null) => {
    if (certificationData && !modal) {
      // Opening modal with specific certification
      setSelectedCertification({
        CERTIFICATION_PID: certificationData.CERTIFICATION_PID,
        ANNOUNCEMENT_ID: certificationData.ANNOUNCEMENT_ID,
      })
      setCurrentCertForPanel(certificationData)
      loadExistingPanelists(certificationData)
      setModal(true)
    } else {
      // Closing modal or toggling without data
      setModal(false)
      // Clear selections when closing
      if (!certificationData) {
        clearForm()
      }
    }
  }

  // Combined Panelist modal: single Autocomplete, options merged from every
  // role list (Agency Director, EEO, Personnel Officer, POC) + the panelist pool,
  // each dropdown option shows a checkbox. Selecting here IS the Panelist field.
  const toggleCombinedPanelistModal = (certificationData = null) => {
    if (certificationData) {
      setSelectedCertification({
        CERTIFICATION_PID: certificationData.CERTIFICATION_PID,
        ANNOUNCEMENT_ID: certificationData.ANNOUNCEMENT_ID,
      })
      setCurrentCertForPanel(certificationData)
      loadExistingPanelists(certificationData)
      // setCombinedPanelistModalOpen(true)
    } else {
      // setCombinedPanelistModalOpen(false)
      if (!certificationData) {
        clearForm()
      }
    }
  }

  // Every option carries both naming conventions (ID/EmployeeID, EmployeeName_LFM/Employee_Name)
  // so the same object works whether it lands in selectedPanelists (keyed by ID) or in
  // selectedAgencyDirector/EEO/PO/POC (keyed by EmployeeID, as read by handleAssignAD's payload)
  const getCombinedPanelistOptions = () => {
    const roleUsers = [
      ...AgencyDirectors.map((u) => ({ ID: u.EmployeeID, EmployeeID: u.EmployeeID, EmployeeName_LFM: u.Employee_Name, Employee_Name: u.Employee_Name, Position: u.DepartmentName, PayGrade: "Agency Director" })),
      ...EeoRepresentative.map((u) => ({ ID: u.EmployeeID, EmployeeID: u.EmployeeID, EmployeeName_LFM: u.Employee_Name, Employee_Name: u.Employee_Name, Position: u.DepartmentName, PayGrade: "EEO" })),
      ...PersonalOfficer.map((u) => ({ ID: u.EmployeeID, EmployeeID: u.EmployeeID, EmployeeName_LFM: u.Employee_Name, Employee_Name: u.Employee_Name, Position: u.DepartmentName, PayGrade: "Personnel Officer" })),
      ...Poc.map((u) => ({ ID: u.EmployeeID, EmployeeID: u.EmployeeID, EmployeeName_LFM: u.Employee_Name, Employee_Name: u.Employee_Name, Position: u.DepartmentName, PayGrade: "POC" })),
    ]

    const panelistPool = allEmployees.map((emp) => ({
      ...emp,
      EmployeeID: emp.ID,
      Employee_Name: emp.EmployeeName_LFM,
    }))

    const seen = new Set()
    return [...roleUsers, ...panelistPool].filter((option) => {
      if (seen.has(option.ID)) return false
      seen.add(option.ID)
      return true
    })
  }

  const getPanelistOptionLabel = (option) =>
    option.EmployeeName_LFM
      ? `${option.EmployeeName_LFM}${option.Position ? ` - ${option.Position}` : ""}${option.PayGrade ? ` (${option.PayGrade})` : ""}`
      : ""

  // Same person can hold multiple roles at once, so each role is its own checkbox column;
  // AD/EEO/PO/POC stay single-select (checking one unchecks whoever held it), Panelist is multi-select
  const handleSingleRoleCheckboxToggle = (setter, currentValue, option) => {
    setter(currentValue?.EmployeeID === option.EmployeeID ? null : option)
  }

  const handlePanelistCheckboxToggle = (option) => {
    setSelectedPanelists((prev) =>
      prev.some((p) => p.ID === option.ID)
        ? prev.filter((p) => p.ID !== option.ID)
        : [...prev, option]
    )
  }

  const getRoleUsers = async () => {
    setLoading(true)
    const params = [
      {
        columnName: "roleName",
        value: "AGENCY-DIRECTOR,EEO,PERSONAL-OFFICER,POC",
        operator: "IN",
        dataType: "varchar(MAX)",
        logicOperator: "AND",
      },
    ]

    const payload = {
      tableName: "fn_get_users",
      searchParams: JSON.stringify(params),
      columns: "*",
      location: "global",
      pageNumber: 1,
      pageSize: 99999,
      sortData: "",
      additionalWhere: "",
      qID: 0,
    }
    try {
      const response = await advanceSearch(payload)
      const { results } = response

      // Filter results based on RoleName
      const agencyDirectors = results.filter((user) => user.RoleName === "AGENCY-DIRECTOR")
      const eeoRepresentatives = results.filter((user) => user.RoleName === "EEO")
      const personalOfficers = results.filter((user) => user.RoleName === "PERSONAL-OFFICER")
      const pocs = results.filter((user) => user.RoleName === "POC")
      setAgencyDirectors(agencyDirectors)
      setEeoRepresentative(eeoRepresentatives)
      setPersonalOfficer(personalOfficers)
      setPoc(pocs)

      setLoading(false)
    } catch (error) {
      console.error("Error fetching data:", error)
      ShowError(
        getFormalApiErrorMessage(
          error,
          "We are unable to load role user details at this time. Please try again shortly."
        )
      )
      setError("Error fetching data. Please try again later.")
      setLoading(false)
    }
  }

  useEffect(() => {
    let isMounted = true
    getRoleUsers()
    return () => {
      isMounted = false
    }
  }, [])

  const handleAgencyDirectorChange = (event, value) => {
    updateFilteredOptions(value?.Dept_Code)
    setSelectedAgencyDirector(value)
  }

  const handleEeoRepresentativeChange = (event, value) => {
    setSelectedEEORepresentative(value)
  }

  const handlePersonalOfficerChange = (event, value) => {
    setSelectedPersonalOfficer(value)
  }

  const handleDepartmentContactChange = (event, value) => {
    setSelectedDepartmentContact(value)
  }

  const getAgencyDirectors = () =>
    AgencyDirectors.map((director) => ({
      ...director,
      label: `${director.Employee_Name} (${director.DepartmentName})`,
    }))

  const getEeoRepresentatives = () =>
    EeoRepresentative.map((rep) => ({
      ...rep,
      label: `${rep.Employee_Name} (${rep.DepartmentName})`,
    }))

  const getPersonalOfficers = () =>
    PersonalOfficer.map((officer) => ({
      ...officer,
      label: `${officer.Employee_Name} (${officer.DepartmentName})`,
    }))

  const getPocs = () =>
    Poc.map((poc) => ({
      ...poc,
      label: `${poc.Employee_Name} (${poc.DepartmentName})`,
    }))

  const extendDateHandler = async () => {
    const payload = {
      certificatioN_PID: "",
      announcemenT_ID: "string",
      expiry: "2024-07-29T07:47:18.746Z",
    }

    try {
      await put(`${baseURL}/Certification/AssignCertification`, payload)
    } catch (error) {
      console.error(error)
    } finally {
      // Handle finally
    }
  }

  const updateFilteredOptions = (deptCode) => {
    if (deptCode) {
      const filteredEeoRep = EeoRepresentative.filter((rep) => rep.Dept_Code === deptCode)
      const filteredPersOfficer = PersonalOfficer.filter((officer) => officer.Dept_Code === deptCode)
      const filteredPoc = Poc.filter((poc) => poc.Dept_Code === deptCode)

      setSelectedEEORepresentative(null)
      setSelectedPersonalOfficer(null)
      setSelectedDepartmentContact(null)
      setEeoRepresentative(filteredEeoRep)
      setPersonalOfficer(filteredPersOfficer)
      setPoc(filteredPoc)
    }
  }

  const getData = async () => {
    setLoading(true)
    const params = [
      {
        columnName: "employee_id",
        value: userData?.profile?.EmployeeID,
        operator: "=",
        dataType: "bigint",
        logicOperator: "AND",
      },
    ]
    const checkAssignee = Role == "EEO" || Role == "POC" || Role == "PERSONAL-OFFICER"
    const tableName = checkAssignee ? "GET-ASSIGN-CERT-LIST" : "CERT-LIST"
    const payload = {
      tableName: tableName,
      searchParams: checkAssignee ? JSON.stringify(params) : "[]",
      columns: "*",
      location: "pmis-global",
      pageNumber: 1,
      pageSize: 100,
      sortData: "",
      additionalWhere: `CERTIFICATION_PID = '${certPid}'`,
      qID: 0,
    }
    try {
      const response = await advanceSearch(payload)
      const { results } = response
      setCdata(results)
      setFilteredCertifications(results)
      setLoading(false)
    } catch (error) {
      console.error("Error fetching data:", error)
      ShowError(
        getFormalApiErrorMessage(
          error,
          "We are unable to load certification data at this time. Please try again shortly."
        )
      )
      setError("Error fetching data. Please try again later.")
      setLoading(false)
    }
  }

  useEffect(() => {
    getData()
  }, [])

  // Loads each cert's applicant-selection status so the "No Applicant Selected"
  // warning can be shown without needing a separate step page.
  useEffect(() => {
    cdata.forEach((cert) => {
      if (cert.CERTIFICATION_PID && !(cert.CERTIFICATION_PID in allNotSelectedByCert)) {
        fetchApplicantSelectionStatus(cert)
      }
    })
  }, [cdata])

  useEffect(() => {
    const debounceSearch = setTimeout(() => {
      const filtered = cdata.filter(
        (cert) =>
          cert.CERTIFICATION_PID?.toLowerCase().includes(searchTerm.toLowerCase()) ||
          cert.ANNOUNCEMENT_ID?.toLowerCase().includes(searchTerm.toLowerCase()) ||
          cert.POSITION_NO?.toLowerCase().includes(searchTerm.toLowerCase()) ||
          cert.PositionTitle?.toLowerCase().includes(searchTerm.toLowerCase()),
      )
      setFilteredCertifications(filtered)
      setLoading(false)
    }, 500)

    return () => clearTimeout(debounceSearch)
  }, [searchTerm, cdata])

  const handleInputChange = (e) => {
    const value = e.target.value
    setSearchTerm(value)
    setLoading(true)
  }

  const handlePageChange = (event, value) => {
    setCurrentPage(value)
  }

  const handleItemsPerPageChange = (event) => {
    setItemsPerPage(Number.parseInt(event.target.value, 10))
    setCurrentPage(1)
  }

  const navigate = useNavigate()
  const renderValue = (value) => (value !== null && value !== undefined ? value : "N/A")

  const paginatedData = filteredCertifications.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage)
  const totalItems = filteredCertifications.length

  const submitRoleAssignment = async (closeModal) => {
    setLoading(true)

    try {
      const payload = {
        certificatioN_PID: selectedCertification?.CERTIFICATION_PID,
        announcemenT_ID: selectedCertification?.ANNOUNCEMENT_ID,
        agency_Director: selectedAgencyDirector?.Employee_Name,
        agency_Director_empid: selectedAgencyDirector?.EmployeeID,
        eeO_Representative: selectedEEORepresentative?.Employee_Name,
        eeO_Representative_empid: selectedEEORepresentative?.EmployeeID,
        personal_officer: selectedPersonalOfficer?.Employee_Name,
        personal_officer_empid: selectedPersonalOfficer?.EmployeeID,
        point_of_Contact: selectedDepartmentContact?.Employee_Name,
        point_of_Contact_empid: selectedDepartmentContact?.EmployeeID,
      }

      await put(`${baseURL}/Certification/AssignCertification`, payload)
      await savePanelists(selectedCertification?.CERTIFICATION_PID)

      ShowSucess("Certificate assigned successfully")
      getData()
    } catch (error) {
      console.error("Error submitting form:", error)
      ShowError(
        getFormalApiErrorMessage(
          error,
          "We are unable to assign certification details at this time. Please try again shortly."
        )
      )
    } finally {
      setLoading(false)
    }
    closeModal()
  }

  const handleAssignAD = () => submitRoleAssignment(toggle)
  const handleAssignCombinedRoles = () => submitRoleAssignment(toggleCombinedPanelistModal)

  const clearForm = () => {
    setSelectedAgencyDirector(null)
    setSelectedEEORepresentative(null)
    setSelectedPersonalOfficer(null)
    setSelectedDepartmentContact(null)
    setSelectedCertification({ CERTIFICATION_PID: null, ANNOUNCEMENT_ID: null })
    setCurrentCertForPanel(null)
    setSelectedPanelists([])
    setExistingPanelists([])
  }

  const handlePacket = async (certificationPID, announcementID) => {
    if (!window.confirm("Are you sure you want to send the certificate packet?")) {
      return
    }

    setLoading(true)
    try {
      const payload = {
        certificatioN_PID: certificationPID,
        announcemenT_ID: announcementID,
        send_Certificate_Packet: true,
      }

      await put(`${baseURL}/Certification/AssignCertification`, payload)
      ShowSucess("Applicants Notified")
      ShowSucess("Certificate packet sent successfully")
      getData()
      if (callUpdateStep) {
        callUpdateStep()
      }
    } catch (error) {
      console.error("Error submitting form:", error)
      ShowError(
        getFormalApiErrorMessage(
          error,
          "We are unable to send the certificate packet at this time. Please try again shortly."
        )
      )
    } finally {
      setLoading(false)
    }
  }

  const handleDeleteCertification = async (certificationPid, announcementId) => {
    if (!window.confirm("Are you sure you want to delete this certification?")) {
      return
    }

    const formData = {
      certificatioN_PID: certificationPid,
      announcemenT_ID: announcementId,
    }

    setLoading(true)
    try {
      const response = await remove(`${baseURL}/Certification/DeleteCertificationPacket`, formData)
      if (response.status === 200) {
        ShowSucess("certification deleted successfully")
        getData()
      } else {
        ShowError(
          "We were unable to delete the certification at this time. Please try again shortly."
        )
      }
    } catch (error) {
      console.error("Error sending feedback:", error)
      ShowError(
        getFormalApiErrorMessage(
          error,
          "We are unable to delete the certification at this time. Please try again shortly."
        )
      )
    } finally {
      setLoading(false)
    }
  }

  const EmployeeID = getUserId(userData)

  // Loads the panelists already assigned to a certification, so the Panelist
  // field in the Assign AD/EEO/PO/POC modal opens pre-populated
  const loadExistingPanelists = async (cert) => {
    setPanelLoading(true)
    try {
      const response = await post(`${baseURL}/PMIS_InterviewPanelAssignments/${cert.CERTIFICATION_PID}`)
      const assignedEmployeeIds = response.map((p) => p.employeeid)
      const preSelectedPanelists = allEmployees.filter((emp) => assignedEmployeeIds.includes(emp.ID))

      setExistingPanelists(response)
      setSelectedPanelists(preSelectedPanelists)
    } catch (error) {
      console.log("Error fetching assigned panelists:", error)
      ShowError(
        getFormalApiErrorMessage(
          error,
          "We are unable to load existing panelists at this time. Please try again shortly."
        )
      )
      setExistingPanelists([])
      setSelectedPanelists([])
    } finally {
      setPanelLoading(false)
    }
  }

  // Diffs selectedPanelists against existingPanelists and creates/removes
  // assignments accordingly. Called as part of the Assign AD/EEO/PO/POC submit.
  const savePanelists = async (certificationId) => {
    const selectedIds = new Set(selectedPanelists.map((p) => p.ID))
    const existingIds = new Set(existingPanelists.map((p) => p.employeeid))

    const panelistsToAdd = selectedPanelists
      .filter((p) => !existingIds.has(p.ID))
      .map((p) => ({
        certificatioN_ID: certificationId,
        employeeid: p.ID,
        isactive: true,
      }))

    const panelistsToRemove = existingPanelists.filter((p) => !selectedIds.has(p.employeeid))

    const promises = []

    if (panelistsToAdd.length > 0) {
      promises.push(post(`${baseURL}/PMIS_InterviewPanelAssignments/Create`, panelistsToAdd))
    }

    panelistsToRemove.forEach((panelist) => {
      promises.push(remove(`${baseURL}/PMIS_InterviewPanelAssignments/${panelist.id}`))
    })

    await Promise.all(promises)
  }

  const fetchQuestions = async (cert) => {
    setScoreCardLoading(true)
    try {
      const response = await post(`${baseURL}/PMIS_Questions/${cert.CERTIFICATION_PID}`)
      setQuestions(response || [])
    } catch (error) {
      console.log("Error fetching questions:", error)
      if (error.response && error.response.status === 404) {
        setQuestions([]) // No questions exist yet
      } else {
        ShowError(
          getFormalApiErrorMessage(
            error,
            "We are unable to load score card questions at this time. Please try again shortly."
          )
        )
        setQuestions([])
      }
    } finally {
      setScoreCardLoading(false)
    }
  }

  const handleOpenScoreCardModal = async (cert) => {
    setCurrentCertForScoreCard(cert)
    setScoreCardModalOpen(true)
    await fetchQuestions(cert)
  }

  const handleCloseScoreCardModal = () => {
    setScoreCardModalOpen(false)
    setCurrentCertForScoreCard(null)
    setQuestions([])
    setNewQuestion("")
    setEditingQuestion(null)
  }

  const handleAddQuestion = async () => {
    if (!newQuestion.trim() || !currentCertForScoreCard) return
    setScoreCardLoading(true)
    const payload = [
      {
        question: newQuestion,
        certificatioN_ID: currentCertForScoreCard.CERTIFICATION_PID,
        announcemenT_ID: currentCertForScoreCard.ANNOUNCEMENT_ID,
        generaL_AVAILIBILITY_ID: currentCertForScoreCard.GENERAL_AVAILIBILITY_ID || "",
        eligibilitY_ID: currentCertForScoreCard.ELIGIBILITY_IDS || "",
        isactive: true,
      },
    ]

    try {
      await post(`${baseURL}/PMIS_Questions/CreateQuestions`, payload)
      ShowSucess("Question added successfully!")
      setNewQuestion("")
      await fetchQuestions(currentCertForScoreCard)
    } catch (error) {
      console.error("Error adding question:", error)
      ShowError(
        getFormalApiErrorMessage(
          error,
          "We are unable to add the question at this time. Please try again shortly."
        )
      )
      setScoreCardLoading(false)
    }
  }

  const handleUpdateQuestion = async () => {
    if (!editingQuestion || !editingQuestion.question.trim()) return
    setScoreCardLoading(true)
    const payload = [{ ...editingQuestion }]

    try {
      await put(`${baseURL}/PMIS_Questions/updateQuestions`, payload)
      ShowSucess("Question updated successfully!")
      setEditingQuestion(null)
      await fetchQuestions(currentCertForScoreCard)
    } catch (error) {
      console.error("Error updating question:", error)
      ShowError(
        getFormalApiErrorMessage(
          error,
          "We are unable to update the question at this time. Please try again shortly."
        )
      )
      setScoreCardLoading(false)
    }
  }

  const handleDeleteQuestion = async (questionId) => {
    if (!window.confirm("Are you sure you want to delete this question?")) return
    setScoreCardLoading(true)
    try {
      await remove(`${baseURL}/PMIS_Questions/${questionId}`)
      ShowSucess("Question deleted successfully!")
      await fetchQuestions(currentCertForScoreCard)
    } catch (error) {
      console.error("Error deleting question:", error)
      ShowError(
        getFormalApiErrorMessage(
          error,
          "We are unable to delete the question at this time. Please try again shortly."
        )
      )
      setScoreCardLoading(false)
    }
  }


  return (
    <>
      {/* <Row className="bg-primary rounded py-3 mb-3">
        <Col xs="4" className="d-flex align-items-center gap-2">
          <FontAwesomeIcon icon={faCertificate} size="lg" />
          <Typography variant="h6">Job Certification Tracking</Typography>
        </Col>
        <Col xs="8">
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-end",
            }}
          >
            <div className="position-relative d-flex align-items-center">
              <FontAwesomeIcon
                icon={faSearch}
                style={{
                  position: "absolute",
                  left: "22px",
                  zIndex: 1,
                  color: "var(--theme-default)",
                  fontSize: "18px",
                }}
              />
              <TextField
                variant="outlined"
                placeholder="Announcement, Position No, Position Name ..."
                value={searchTerm}
                onChange={handleInputChange}
                style={{
                  borderRadius: "20px",
                  marginLeft: "10px",
                  backgroundColor: "white",
                  paddingLeft: "40px",
                  width: "550px",
                }}
                InputProps={{
                  style: { borderRadius: "20px" },
                }}
                size="small"
              />
            </div>
          </div>
        </Col>
      </Row> */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "10px",
        }}
      >
        {/* <ul>
          <li style={{ fontWeight: "bold" }}>
            * In sign forms, the signature selector is visible only when the
            signature is verified.
          </li>
          <li style={{ fontWeight: "bold" }}>
            ** Certification(s) will be visible to Agency Director when
            Certificates("Send Certificate" button is clicked) are sent.
          </li>
          <li style={{ fontWeight: "bold" }}>
            *** The "Send Certificate" button is enabled when EEO, Personnel
            Officer, Point of Contact sign their respective forms.
          </li>
        </ul> */}
        {/* <ul>
          <Button variant="contained" onClick={() => setShowCharts(!showCharts)} style={{ display: "flex", gap: "10px" }}>
            <FontAwesomeIcon icon={faChartLine} size="lg" /> {showCharts ? "Hide Charts" : "Show Charts"}
          </Button>
        </ul> */}
      </div>
      {loading ? (
        <>
          {[1, 2, 3].map((_, index) => (
            <Col xs="12" key={index} className="p-2">
              <Card>
                <CardHeader
                  title={
                    <div className="d-flex justify-content-between align-items-center">
                      <Skeleton variant="text" width="60%" />
                    </div>
                  }
                />
                <CardContent>
                  <Grid container spacing={1}>
                    <Grid item xs={12}>
                      <div className="d-flex gap-4">
                        <Skeleton variant="text" width="30%" />
                        <Skeleton variant="text" width="30%" />
                        <Skeleton variant="text" width="30%" />
                      </div>
                    </Grid>
                    <Grid item xs={6}>
                      <Skeleton variant="text" width="80%" />
                      <Skeleton variant="text" width="80%" />
                    </Grid>
                    <Grid item xs={6}>
                      <Skeleton variant="text" width="80%" />
                      <Skeleton variant="text" width="80%" />
                    </Grid>
                    <Grid item xs={6}>
                      <Skeleton variant="text" width="80%" />
                    </Grid>
                    <Grid item xs={6}>
                      <Skeleton variant="text" width="80%" />
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>
            </Col>
          ))}
        </>
      ) : (
        <>
          {paginatedData.length > 0 ? (
            <Row>
              {showCharts && (
                <Col xs="12">
                  <CertificationCharts data={cdata} />
                </Col>
              )}
              {paginatedData.map((cert, index) => (
                <Col xs="12" key={index} className="p-2">
                  <Card>
                    <CardHeader
                      title={
                        <div className="d-flex justify-content-between align-items-start">
                          <div>
                            <div className="d-flex gap-2">
                              <Typography
                                variant="h6"
                                sx={{ cursor: "pointer" }}
                              >
                                <FontAwesomeIcon
                                  color="var(--theme-default)"
                                  icon={faFileCertificate}
                                  size="lg"
                                />{" "}
                                Certification ID:{" "}
                                <u>{renderValue(cert.CERTIFICATION_PID)}</u>
                              </Typography>
                              {cert?.EEO_Representative == EmployeeID ||
                                cert?.Point_of_Contact == EmployeeID ||
                                cert?.Personal_officer == EmployeeID ||
                                cert?.Agency_Director === EmployeeID ? null : (
                                <Button
                                  onClick={() =>
                                    handleDeleteCertification(
                                      cert.CERTIFICATION_PID,
                                      cert.ANNOUNCEMENT_ID
                                    )
                                  }
                                  variant="contained"
                                  size="small"
                                  className="d-flex gap-2"
                                  color="error"
                                >
                                  <FontAwesomeIcon
                                    icon={faDeleteRight}
                                    size="lg"
                                  />{" "}
                                  Delete
                                </Button>
                              )}
                            </div>
                            <p className="d-flex ml-2 align-items-center gap-2">
                              <FontAwesomeIcon
                                color="var(--theme-default)"
                                icon={faBullhorn}
                                size="md"
                                style={{ cursor: "pointer" }}
                              />{" "}
                              {renderValue(cert.ANNOUNCEMENT_ID)}
                              <Chip
                                size="small"
                                label={"Open"}
                                sx={{
                                  color: "white",
                                  background: "lightgreen",
                                }}
                              />
                            </p>
                          </div>
                          <div className="d-flex gap-3 align-items-center">
                            <Typography variant="body2">
                              <FontAwesomeIcon
                                color="var(--theme-default)"
                                icon={faUserGroup}
                                size="sm"
                                style={{ cursor: "pointer" }}
                              />{" "}
                              Applicants:{" "}
                              <Chip
                                size="small"
                                sx={{
                                  color: "white",
                                  background: "var(--theme-default)",
                                }}
                                label={renderValue(
                                  cert.TotalApp ? cert.TotalApp : 0
                                )}
                              />
                            </Typography>
                            <Typography variant="body2">
                              <FontAwesomeIcon
                                color="grey"
                                icon={faShieldCheck}
                                size="sm"
                                style={{ cursor: "pointer" }}
                              />{" "}
                              Contacted:{" "}
                              <Chip
                                size="small"
                                sx={{ color: "white", background: "grey" }}
                                label={renderValue(
                                  cert.Contacted === "N/A" ? 0 : cert.Contacted
                                )}
                              />
                            </Typography>
                            <Typography variant="body2">
                              <FontAwesomeIcon
                                color="lightgreen"
                                icon={faShieldCheck}
                                size="sm"
                                style={{ cursor: "pointer" }}
                              />{" "}
                              Scheduled:{" "}
                              <Chip
                                size="small"
                                sx={{
                                  color: "white",
                                  background: "lightgreen",
                                }}
                                label={renderValue(
                                  cert.Scheduled === "N/A" ? 0 : cert.Scheduled
                                )}
                              />
                            </Typography>
                            <Typography variant="body2">
                              <FontAwesomeIcon
                                color="lightcoral"
                                icon={faShieldXmark}
                                size="sm"
                                style={{ cursor: "pointer" }}
                              />{" "}
                              Interviewed:{" "}
                              <Chip
                                sx={{
                                  color: "white",
                                  background: "lightcoral",
                                }}
                                label={renderValue(
                                  cert.Interviewed === "N/A"
                                    ? 0
                                    : cert.Interviewed
                                )}
                                size="small"
                              />
                            </Typography>
                          </div>
                        </div>
                      }
                    />
                    <CardContent>
                      <Grid
                        container
                        spacing={1}
                        style={{ position: "relative" }}
                      >
                        <Grid item xs={12}>
                          <div className="d-flex">
                            <div style={{ textAlign: "left" }}>
                              <Typography variant="body1">
                                <FontAwesomeIcon
                                  color="var(--theme-default)"
                                  icon={faSuitcase}
                                  size="md"
                                  style={{ cursor: "pointer" }}
                                />{" "}
                                Position: {renderValue(cert.POSITION_NO)} -{" "}
                                {renderValue(cert.PositionTitle)}
                              </Typography>
                            </div>
                            {Role != "EEO" &&
                              Role != "POC" &&
                              Role != "PERSONAL-OFFICER" && (
                                <div
                                  style={{
                                    position: "absolute",
                                    right: "11px",
                                    top: "-35px",
                                    width: "504px",
                                  }}
                                >
                                  <CountdownProgressBar
                                    targetDate={cert?.created_on}
                                    expiryDate={cert?.Expiry_on}
                                    getData={getData}
                                    cert={cert}
                                  />
                                </div>
                              )}
                          </div>
                        </Grid>
                        <Grid
                          item
                          xs={4}
                          display={"flex"}
                          alignItems={"center"}
                          gap={3}
                        >
                          <Typography variant="body1">
                            <FontAwesomeIcon
                              color="var(--theme-default)"
                              icon={faArrowTrendUp}
                              size="sm"
                              style={{ cursor: "pointer" }}
                            />{" "}
                            Step: {renderValue(cert.StepRange)}
                          </Typography>
                          <Typography variant="body1">
                            <FontAwesomeIcon
                              color="var(--theme-default)"
                              icon={faStars}
                              size="sm"
                              style={{ cursor: "pointer" }}
                            />{" "}
                            Grade: {renderValue(cert.Grade)}
                          </Typography>
                        </Grid>
                        <Grid
                          item
                          xs={4}
                          display={"flex"}
                          alignItems={"center"}
                          gap={3}
                        >
                          <Typography variant="body1">
                            <FontAwesomeIcon
                              color="var(--theme-default)"
                              icon={faCoins}
                              size="sm"
                              style={{ cursor: "pointer" }}
                            />{" "}
                            Rate: ${renderValue(cert.HourlyRateRange)}
                          </Typography>
                          <Typography variant="body1">
                            <FontAwesomeIcon
                              color="var(--theme-default)"
                              icon={faDollarSign}
                              size="sm"
                              style={{ cursor: "pointer" }}
                            />{" "}
                            Salary: ${renderValue(cert.SalaryRange)}
                          </Typography>
                        </Grid>
                        <Grid item xs={4}></Grid>
                        <Grid
                          item
                          xs={4}
                          gap={4}
                          display={"flex"}
                          alignItems={"center"}

                        >
                          <Typography variant="body1">
                            <FontAwesomeIcon
                              color="var(--theme-default)"
                              icon={faListDropdown}
                              size="sm"
                              style={{ cursor: "pointer" }}
                            />{" "}
                            Eligibility ID's:{" "}
                            {renderValue(cert.ELIGIBILITY_IDS)}
                          </Typography>
                        </Grid>
                        <Grid
                          item
                          xs={4}
                          gap={4}
                          display={"flex"}
                          alignItems={"center"}>
                          <Typography variant="body1">
                            <FontAwesomeIcon
                              color="var(--theme-default)"
                              icon={faList}
                              size="sm"
                              style={{ cursor: "pointer" }}
                            />{" "}
                            General Availability ID's:{" "}
                            {renderValue(cert.GENERAL_AVAILIBILITY_ID)}
                          </Typography>
                        </Grid>
                        <Grid item xs={4} gap={4}>
                          <Typography
                            variant="body1"
                            sx={{
                              textAlign: "right",
                              display: "flex",
                              justifyContent: "flex-end",
                              alignItems: "center",
                              gap: "10px",
                            }}
                          >
                            {/* {cert.updateon_sign_EEO_Representative &&
                              cert.updateon_sign_Personal_officer &&
                              cert.updateon_sign_Point_of_Contact && (
                                <Button
                                  color="primary"
                                  size="small"
                                  sx={{
                                    marginRight: "25px",
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "10px",
                                    borderRadius: "20px",
                                  }}
                                  variant="contained"
                                  onClick={() =>
                                    navigate("/view-packet", {
                                      state: { cert },
                                    })
                                  }
                                >
                                  <FontAwesomeIcon
                                    color="white"
                                    icon={faFileCertificate}
                                    size="sm"
                                    style={{ cursor: "pointer" }}
                                  />{" "}
                                  {showPdf ? "Close" : "View"} Certificate
                                  Packet
                                </Button>
                              )} */}
                            {cert?.Return_To_HR && (
                              <Button
                                color="secondary"
                                size="large"
                                onClick={() => toggleDocumentListModal(cert)}
                                sx={{
                                  marginRight: "25px",
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "10px",
                                  borderRadius: "20px",
                                }}
                                style={{ fontSize: "16px" }}
                                variant="contained"
                              >
                                <FontAwesomeIcon
                                  icon={faFolderOpen}
                                  size="lg"
                                  style={{ cursor: "pointer" }}
                                />
                                Completed Certification Packet Documents
                              </Button>
                            )}
                          </Typography>
                        </Grid>
                        <Grid item xs={5} gap={2}>
                          <Typography
                            variant="body1"
                            sx={{
                              // textAlign: "right",
                              display: "flex",
                              // alignItems: "center",
                              gap: "8px",
                              // justifyContent: "flex-end",
                              alignItems: "center",
                              flexWrap: "wrap",
                            }}
                          >
                            {allNotSelectedByCert[cert.CERTIFICATION_PID] && (
                              <Typography
                                component="span"
                                sx={{ color: "error.main", fontWeight: "bold" }}
                              >
                                No Applicant Selected. Re-Certification is required.
                              </Typography>
                            )}
                            {/* {cert.updateon_sign_EEO_Representative &&
                              cert.updateon_sign_Personal_officer &&
                              cert.updateon_sign_Point_of_Contact &&
                              Role != "EEO" &&
                              Role != "POC" &&
                              Role != "PERSONAL-OFFICER" &&
                              Role != "AGENCY-DIRECTOR" && (
                                <>
                                  {cert.Send_Certificate_Packet === true ? (
                                    <Button
                                      color="success"
                                      sx={{
                                        marginRight: "25px",
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "10px",
                                        borderRadius: "20px",
                                      }}
                                      variant="outlined"
                                      size="small"
                                    >
                                      Packet Sent
                                    </Button>
                                  ) : (
                                    <Button
                                      color="primary"
                                      size="small"
                                      sx={{
                                        marginRight: "25px",
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "10px",
                                        borderRadius: "20px",
                                      }}
                                      variant="contained"
                                      onClick={() =>
                                        handlePacket(
                                          cert.CERTIFICATION_PID,
                                          cert.ANNOUNCEMENT_ID
                                        )
                                      }
                                    >
                                      <FontAwesomeIcon
                                        color="white"
                                        icon={faSend}
                                        size="sm"
                                        style={{ cursor: "pointer" }}
                                      />
                                      Send Certificate Packet
                                    </Button>
                                  )}
                                </>
                              )} */}

                            {/* Moved to the "Step 3: View certification" heading row in CertificationDetailsPage.jsx. */}

                            {/* {!cert.Agency_Director && cert.DOA_Director_Approvel_request &&
                              Role != "EEO" &&
                              Role != "POC" &&
                              Role != "PERSONAL-OFFICER" &&
                              Role != "DOA-DIRECTOR" &&
                              Role != "AGENCY-DIRECTOR" && (
                                <Button
                                  color="primary"
                                  size="small"
                                  sx={{
                                    marginRight: "25px",
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "10px",
                                    borderRadius: "20px",
                                  }}
                                  variant="contained"
                                  onClick={() =>
                                    toggle({
                                      CERTIFICATION_PID: cert.CERTIFICATION_PID,
                                      ANNOUNCEMENT_ID: cert.ANNOUNCEMENT_ID,
                                    })
                                  }
                                  style={{ fontSize: "12px" }}
                                >
                                  <FontAwesomeIcon
                                    color="white"
                                    icon={faSend}
                                    size="sm"
                                    style={{ cursor: "pointer" }}
                                  />
                                  Assign AD
                                </Button>
                              )}
                            {!cert.Point_of_Contact &&
                              cert.Agency_Approvel_request &&
                              Role != "EEO" &&
                              Role != "POC" &&
                              Role != "PERSONAL-OFFICER" &&
                              Role != "AGENCY-DIRECTOR" && (
                                <Button
                                  color="primary"
                                  size="small"
                                  sx={{
                                    marginRight: "25px",
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "10px",
                                    borderRadius: "20px",
                                  }}
                                  style={{ fontSize: "12px" }}
                                  variant="contained"
                                  onClick={() =>
                                    toggle({
                                      CERTIFICATION_PID: cert.CERTIFICATION_PID,
                                      ANNOUNCEMENT_ID: cert.ANNOUNCEMENT_ID,
                                    })
                                  }
                                >
                                  <FontAwesomeIcon
                                    color="white"
                                    icon={faSend}
                                    size="sm"
                                    style={{ cursor: "pointer" }}
                                  />
                                  Assign POC
                                </Button>
                              )}
                            {cert.Point_of_Contact_signid &&
                              !cert.EEO_Representative &&
                              !cert.Personal_officer &&
                              Role != "EEO" &&
                              Role == "POC" &&
                              Role != "PERSONAL-OFFICER" &&
                              Role != "AGENCY-DIRECTOR" && (
                                <Button
                                  color="primary"
                                  size="small"
                                  sx={{
                                    marginRight: "25px",
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "10px",
                                    borderRadius: "20px",
                                  }}
                                  variant="contained"
                                  onClick={() =>
                                    toggle({
                                      CERTIFICATION_PID: cert.CERTIFICATION_PID,
                                      ANNOUNCEMENT_ID: cert.ANNOUNCEMENT_ID,
                                    })
                                  }
                                  style={{ fontSize: "12px" }}
                                >
                                  <FontAwesomeIcon
                                    color="white"
                                    icon={faSend}
                                    size="sm"
                                    style={{ cursor: "pointer" }}
                                  />
                                  Assign EEO & Personnel Officer
                                </Button>
                              )}

                            {cert.EEO_Representative == EmployeeID && (
                              <Button
                                color="primary"
                                size="small"
                                disabled={
                                  cert.EEO_Representative_signid ? true : false
                                }
                                onClick={() =>
                                  navigate(`/certificate-packet`, {
                                    state: { cert },
                                  })
                                }
                                sx={{
                                  marginRight: "25px",
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "10px",
                                  borderRadius: "20px",
                                }}
                                style={{ fontSize: "12px" }}
                                variant="contained"
                              >
                                <FontAwesomeIcon
                                  color="white"
                                  icon={faSignature}
                                  size="sm"
                                  style={{ cursor: "pointer" }}
                                />{" "}
                                Sign Forms
                              </Button>
                            )}
                            {cert.Personal_officer == EmployeeID && (
                              <Button
                                color="primary"
                                size="small"
                                disabled={
                                  cert.Personal_officer_signid ? true : false
                                }
                                onClick={() =>
                                  navigate(`/certificate-packet`, {
                                    state: { cert },
                                  })
                                }
                                sx={{
                                  marginRight: "25px",
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "10px",
                                  borderRadius: "20px",
                                }}
                                style={{ fontSize: "12px" }}
                                variant="contained"
                              >
                                <FontAwesomeIcon
                                  color="white"
                                  icon={faSignature}
                                  size="sm"
                                  style={{ cursor: "pointer" }}
                                />{" "}
                                Sign Forms
                              </Button>
                            )}
                            {cert.Point_of_Contact == EmployeeID && (
                              <Button
                                color="primary"
                                size="small"
                                disabled={
                                  cert.Point_of_Contact_signid ? true : false
                                }
                                onClick={() =>
                                  navigate(`/certificate-packet`, {
                                    state: { cert },
                                  })
                                }
                                sx={{
                                  marginRight: "25px",
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "10px",
                                  borderRadius: "20px",
                                }}
                                style={{ fontSize: "12px" }}
                                variant="contained"
                              >
                                <FontAwesomeIcon
                                  color="white"
                                  icon={faSignature}
                                  size="sm"
                                  style={{ cursor: "pointer" }}
                                />{" "}
                                Sign Forms
                              </Button>
                            )} */}

                            {/* {(cert.EEO_Representative == EmployeeID ||
                              cert.Point_of_Contact == EmployeeID) && (
                              <>
                                <Button
                                  color="info"
                                  size="small"
                                  onClick={() => handleOpenPanelModal(cert)}
                                  sx={{
                                    marginRight: "25px",
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "10px",
                                    borderRadius: "20px",
                                  }}
                                  style={{ fontSize: "12px" }}
                                  variant="contained"
                                >
                                  <FontAwesomeIcon
                                    icon={faUserGroup}
                                    size="sm"
                                  />
                                  Assign Panel
                                </Button>
                                <Button
                                  color="secondary"
                                  size="small"
                                  onClick={() => handleOpenScoreCardModal(cert)}
                                  sx={{ borderRadius: "20px" }}
                                  variant="contained"
                                  style={{ fontSize: "12px" }}
                                >
                                  <FontAwesomeIcon
                                    icon={faList}
                                    style={{ marginRight: "8px" }}
                                    size="sm"
                                  />
                                  Score Criteria Qs
                                </Button>
                              </>
                            )} */}

                            {/* {Role != "EEO" &&
                              Role != "POC" &&
                              Role != "PERSONAL-OFFICER" &&
                              Role != "AGENCY-DIRECTOR" && (
                                <Button
                                  color="secondary"
                                  size="small"
                                  onClick={() =>
                                    toggleCombinedPanelistModal({
                                      CERTIFICATION_PID: cert.CERTIFICATION_PID,
                                      ANNOUNCEMENT_ID: cert.ANNOUNCEMENT_ID,
                                    })
                                  }
                                  sx={{
                                    marginRight: "25px",
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "10px",
                                    borderRadius: "20px",
                                  }}
                                  style={{ fontSize: "12px" }}
                                  variant="contained"
                                >
                                  <FontAwesomeIcon
                                    color="white"
                                    icon={faUserGroup}
                                    size="sm"
                                    style={{ cursor: "pointer" }}
                                  />
                                  Assign Roles (All Members)
                                </Button>
                              )} */}

                            {/* View Applicants / Assign GG1 Recruitment moved to the "Step 3: View certification" heading row in CertificationDetailsPage.jsx. */}
                          </Typography>
                        </Grid>
                        <Grid item xs={7} gap={4}>
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              gap: "5px",
                            }}
                          >
                            <Typography
                              variant="body2"
                              sx={{
                                textAlign: "center",
                                justifyContent: "center",
                                display: "flex",
                                alignItems: "center",
                                gap: "10px",
                              }}
                            >
                              <b>Point of Contract:</b>
                              <FontAwesomeIcon
                                color={
                                  cert.Point_of_Contact
                                    ? "green"
                                    : "lightgrey"
                                }
                                icon={
                                  cert.Point_of_Contact
                                    ? faCheckCircle
                                    : faCircle
                                }
                                size="sm"
                              />
                            </Typography>
                            <Typography
                              variant="body2"
                              sx={{
                                textAlign: "center",
                                justifyContent: "center",
                                display: "flex",
                                alignItems: "center",
                                gap: "10px",
                              }}
                            >
                              <b>EEO Representative:</b>
                              <FontAwesomeIcon
                                color={
                                  cert.EEO_Representative
                                    ? "green"
                                    : "lightgrey"
                                }
                                icon={
                                  cert.EEO_Representative
                                    ? faCheckCircle
                                    : faCircle
                                }
                                size="sm"
                              />
                            </Typography>
                            <Typography
                              variant="body2"
                              sx={{
                                textAlign: "center",
                                justifyContent: "center",
                                display: "flex",
                                alignItems: "center",
                                gap: "10px",
                              }}
                            >
                              <b>Personnel Officer:</b>
                              <FontAwesomeIcon
                                color={
                                  cert.Personal_officer
                                    ? "green"
                                    : "lightgrey"
                                }
                                icon={
                                  cert.Personal_officer
                                    ? faCheckCircle
                                    : faCircle
                                }
                                size="sm"
                              />
                            </Typography>

                            <Typography
                              variant="body2"
                              sx={{
                                textAlign: "center",
                                justifyContent: "center",
                                display: "flex",
                                alignItems: "center",
                                gap: "10px",
                              }}
                            >
                              <b>Agency Director:</b>
                              <FontAwesomeIcon
                                color={
                                  cert.Agency_Director ? "green" : "lightgrey"
                                }
                                icon={
                                  cert.Agency_Director ? faCheckCircle : faCircle
                                }
                                size="sm"
                              />
                            </Typography>
                          </div>
                        </Grid>
                      </Grid>
                    </CardContent>
                  </Card>
                </Col>
              ))}
            </Row>
          ) : (
            <Typography
              variant="body1"
              align="center"
              style={{ marginTop: "20px" }}
            >
              No certifications found.
            </Typography>
          )}
          {/* {totalItems > itemsPerPage && (
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginTop: "20px",
                background: "#fff",
                padding: "10px",
              }}
            >
              <FormControl variant="outlined" style={{ minWidth: 120 }}>
                <InputLabel>Items per page</InputLabel>
                <Select
                  value={itemsPerPage}
                  onChange={handleItemsPerPageChange}
                  label="Items per page"
                  size="small"
                >
                  <MenuItem value={5}>5</MenuItem>
                  <MenuItem value={10}>10</MenuItem>
                  <MenuItem value={25}>25</MenuItem>
                  <MenuItem value={50}>50</MenuItem>
                </Select>
              </FormControl>
              <Pagination
                count={Math.ceil(totalItems / itemsPerPage)}
                page={currentPage}
                onChange={handlePageChange}
              />
            </div>
          )} */}
        </>
      )
      }

      {/* Fixed Modal - moved outside the map loop */}
      <Modal size="xl" isOpen={modal} toggle={() => toggle()}>
        <ModalBody>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "10px" }}>
            <Typography variant="h6">
              Assign Panelist, EEO, POC, PO & Agency Director for Certification
            </Typography>
          </div>
          <TableContainer component={Paper} sx={{ maxHeight: 800 }}>
            <Table stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell width={200}>Role</TableCell>
                  <TableCell>Assign Authoritys</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {/* Find the current cert based on selectedCertification */}
                {(() => {
                  const currentCert = paginatedData.find(
                    (cert) =>
                      cert.CERTIFICATION_PID ===
                      selectedCertification?.CERTIFICATION_PID &&
                      cert.ANNOUNCEMENT_ID ===
                      selectedCertification?.ANNOUNCEMENT_ID
                  );

                  return (
                    <>
                      {!currentCert?.Agency_Approvel_request && (
                        <TableRow>
                          <TableCell>Agency Director</TableCell>
                          <TableCell>
                            <Autocomplete
                              value={selectedAgencyDirector}
                              onChange={handleAgencyDirectorChange}
                              options={getAgencyDirectors()}
                              getOptionLabel={(option) => option.label}
                              ListboxProps={{ style: { maxHeight: 320 } }}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  label="Agency Director"
                                  variant="outlined"
                                />
                              )}
                            />
                          </TableCell>
                        </TableRow>
                      )}
                      <TableRow>
                        <TableCell>EEO Representative</TableCell>
                        <TableCell>
                          <Autocomplete
                            value={selectedEEORepresentative}
                            onChange={handleEeoRepresentativeChange}
                            options={getEeoRepresentatives()}
                            getOptionLabel={(option) => option.label}
                            ListboxProps={{ style: { maxHeight: 320 } }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label="EEO Representative"
                                variant="outlined"
                              />
                            )}
                          />
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell>Personnel officer</TableCell>
                        <TableCell>
                          <Autocomplete
                            value={selectedPersonalOfficer}
                            onChange={handlePersonalOfficerChange}
                            options={getPersonalOfficers()}
                            getOptionLabel={(option) => option.label}
                            ListboxProps={{ style: { maxHeight: 320 } }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label="Personnel Officer"
                                variant="outlined"
                              />
                            )}
                          />
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell>Point of Contact</TableCell>
                        <TableCell>
                          <Autocomplete
                            value={selectedDepartmentContact}
                            onChange={handleDepartmentContactChange}
                            options={getPocs()}
                            getOptionLabel={(option) => option.label}
                            ListboxProps={{ style: { maxHeight: 320 } }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label="Point of Contact"
                                variant="outlined"
                              />
                            )}
                          />
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell>Panelist</TableCell>
                        <TableCell>
                          <Autocomplete
                            multiple
                            disableCloseOnSelect
                            value={selectedPanelists}
                            onChange={(event, newValue) => setSelectedPanelists(newValue)}
                            options={allEmployees}
                            getOptionLabel={(option) =>
                              option.EmployeeName_LFM
                                ? `${option.EmployeeName_LFM}${option.Position ? ` - ${option.Position}` : ""}${option.PayGrade ? ` (${option.PayGrade})` : ""}`
                                : ""
                            }
                            isOptionEqualToValue={(option, value) => option.ID === value.ID}
                            loading={panelLoading}
                            ListboxProps={{ style: { maxHeight: 320 } }}
                            renderOption={(props, option, { selected }) => (
                              <li {...props} key={option.ID}>
                                <Checkbox checked={selected} style={{ marginRight: 8 }} />
                                {option.EmployeeName_LFM}
                                {option.Position ? ` - ${option.Position}` : ""}
                                {option.PayGrade ? ` (${option.PayGrade})` : ""}
                              </li>
                            )}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label="Panelist"
                                variant="outlined"
                              />
                            )}
                          />
                        </TableCell>
                      </TableRow>
                    </>
                  );
                })()}
              </TableBody>
            </Table>
          </TableContainer>
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={() => toggle()}>
            Cancel
          </Button>{" "}
          <Button variant="contained" color="primary" onClick={handleAssignAD}>
            Submit
          </Button>
        </ModalFooter>
      </Modal>

      {/* Combined Roles Modal - one row per member, 5 role checkboxes on the right so the same person can hold multiple roles */}
      {/* <Modal size="xl" isOpen={combinedPanelistModalOpen} toggle={() => toggleCombinedPanelistModal()}>
        <ModalHeader toggle={() => toggleCombinedPanelistModal()}>
          Assign Panelist, EEO, POC, PO & Agency Director for Certification
        </ModalHeader>
        <ModalBody>
          <Box sx={{ mb: 1 }}>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                flexWrap: "wrap",
                gap: "4px",
                px: 2,
                py: 0.75,
                border: "1px solid #e0e0e0",
                borderRadius: 1,
                backgroundColor: "#fafafa",
                pointerEvents: "none",
              }}
            >
              <span style={{ fontSize: "0.875rem" }}>PAULINO, THOMAS Q - DOA - DIVISION OF ACCOUNTS (Agency Director)</span>
              <span style={{ display: "flex", alignItems: "center", flexWrap: "wrap" }}>
                <FormControlLabel label="AD" sx={{ mr: 1, opacity: 0.45 }} control={<Checkbox size="small" disabled />} />
                <FormControlLabel label="EEO" sx={{ mr: 1, opacity: 0.45 }} control={<Checkbox size="small" disabled />} />
                <FormControlLabel label="PO" sx={{ mr: 1, opacity: 0.45 }} control={<Checkbox size="small" disabled />} />
                <FormControlLabel label="POC" sx={{ mr: 1 }} control={<Checkbox size="small" checked disabled sx={{ color: "primary.main", "&.Mui-checked": { color: "primary.main" } }} />} />
                <FormControlLabel label="Panelist" control={<Checkbox size="small" disabled sx={{ opacity: 0.45 }} />} />
              </span>
            </Box>
          </Box>
          <Autocomplete
            options={getCombinedPanelistOptions()}
            getOptionLabel={getPanelistOptionLabel}
            disableCloseOnSelect
            ListboxProps={{ style: { maxHeight: 400 } }}
            renderInput={(params) => (
              <TextField
                {...params}
                variant="outlined"
                label="Search Member"
                placeholder="Type a name to filter..."
              />
            )}
            renderOption={(props, option) => (
              <li
                {...props}
                key={option.ID}
                style={{ display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: "4px" }}
              >
                <span>{getPanelistOptionLabel(option)}</span>
                <span
                  onMouseDown={(event) => event.stopPropagation()}
                  style={{ display: "flex", alignItems: "center", flexWrap: "wrap" }}
                >
                  <FormControlLabel
                    label="AD"
                    sx={{ mr: 1 }}
                    control={
                      <Checkbox
                        size="small"
                        checked={selectedAgencyDirector?.EmployeeID === option.EmployeeID}
                        onChange={() =>
                          handleSingleRoleCheckboxToggle(setSelectedAgencyDirector, selectedAgencyDirector, option)
                        }
                      />
                    }
                  />
                  <FormControlLabel
                    label="EEO"
                    sx={{ mr: 1 }}
                    control={
                      <Checkbox
                        size="small"
                        checked={selectedEEORepresentative?.EmployeeID === option.EmployeeID}
                        onChange={() =>
                          handleSingleRoleCheckboxToggle(setSelectedEEORepresentative, selectedEEORepresentative, option)
                        }
                      />
                    }
                  />
                  <FormControlLabel
                    label="PO"
                    sx={{ mr: 1 }}
                    control={
                      <Checkbox
                        size="small"
                        checked={selectedPersonalOfficer?.EmployeeID === option.EmployeeID}
                        onChange={() =>
                          handleSingleRoleCheckboxToggle(setSelectedPersonalOfficer, selectedPersonalOfficer, option)
                        }
                      />
                    }
                  />
                  <FormControlLabel
                    label="POC"
                    sx={{ mr: 1 }}
                    control={
                      <Checkbox
                        size="small"
                        checked={selectedDepartmentContact?.EmployeeID === option.EmployeeID}
                        onChange={() =>
                          handleSingleRoleCheckboxToggle(setSelectedDepartmentContact, selectedDepartmentContact, option)
                        }
                      />
                    }
                  />
                  <FormControlLabel
                    label="Panelist"
                    control={
                      <Checkbox
                        size="small"
                        checked={selectedPanelists.some((p) => p.ID === option.ID)}
                        onChange={() => handlePanelistCheckboxToggle(option)}
                      />
                    }
                  />
                </span>
              </li>
            )}
          />
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={() => toggleCombinedPanelistModal()}>
            Cancel
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={handleAssignCombinedRoles}
          >
            Save Changes
          </Button>
        </ModalFooter>
      </Modal> */}

      {/* Score Card Criteria Modal */}
      <Modal
        isOpen={scoreCardModalOpen}
        toggle={handleCloseScoreCardModal}
        size="lg"
      >
        <ModalHeader toggle={handleCloseScoreCardModal}>
          Score Card Criteria for Certification:{" "}
          {currentCertForScoreCard?.CERTIFICATION_PID}
        </ModalHeader>
        <ModalBody>
          <Box sx={{ display: "flex", alignItems: "center", mb: 2, gap: 1 }}>
            <TextField
              fullWidth
              label="New Question"
              variant="outlined"
              value={newQuestion}
              onChange={(e) => setNewQuestion(e.target.value)}
              disabled={scoreCardLoading}
            />
            <Button
              variant="contained"
              onClick={handleAddQuestion}
              disabled={scoreCardLoading || !newQuestion.trim()}
              sx={{ whiteSpace: "nowrap" }}
            >
              <FontAwesomeIcon icon={faPlus} style={{ marginRight: "8px" }} />{" "}
              Add
            </Button>
          </Box>
          <Paper
            sx={{ maxHeight: 400, overflow: "auto", position: "relative" }}
          >
            {scoreCardLoading && (
              <Box
                sx={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  backgroundColor: "rgba(255, 255, 255, 0.7)",
                  zIndex: 1,
                }}
              >
                <CircularProgress />
              </Box>
            )}
            <List>
              {questions.length > 0 ? (
                questions.map((q) =>
                  editingQuestion?.id === q.id ? (
                    <ListItem key={q.id}>
                      <TextField
                        fullWidth
                        variant="outlined"
                        value={editingQuestion.question}
                        onChange={(e) =>
                          setEditingQuestion({
                            ...editingQuestion,
                            question: e.target.value,
                          })
                        }
                      />
                      <IconButton
                        onClick={handleUpdateQuestion}
                        color="primary"
                      >
                        <FontAwesomeIcon icon={faSave} />
                      </IconButton>
                      <IconButton onClick={() => setEditingQuestion(null)}>
                        <FontAwesomeIcon icon={faDeleteRight} />
                      </IconButton>
                    </ListItem>
                  ) : (
                    <ListItem
                      key={q.id}
                      secondaryAction={
                        <>
                          <IconButton
                            edge="end"
                            aria-label="edit"
                            onClick={() => setEditingQuestion({ ...q })}
                          >
                            <FontAwesomeIcon icon={faEdit} />
                          </IconButton>
                          <IconButton
                            edge="end"
                            aria-label="delete"
                            onClick={() => handleDeleteQuestion(q.id)}
                            sx={{ ml: 1 }}
                          >
                            <FontAwesomeIcon icon={faTrash} />
                          </IconButton>
                        </>
                      }
                    >
                      <ListItemText primary={q.question} />
                    </ListItem>
                  )
                )
              ) : (
                <ListItem>
                  <ListItemText primary="No questions have been added yet." />
                </ListItem>
              )}
            </List>
          </Paper>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={handleCloseScoreCardModal}>
            Close
          </Button>
        </ModalFooter>
      </Modal>

      {/* Certificate Package Document List Modal */}
      <Modal
        isOpen={documentListModalOpen}
        toggle={() => toggleDocumentListModal()}
        size="xl"
      >
        <ModalHeader toggle={() => toggleDocumentListModal()}>
          <div style={{ display: "flex", alignItems: "center", gap: "16px", justifyContent: "space-between" }}>
            <span>
              Completed Certification Packet Documents of {" "}
              {currentCertForDocumentList?.CERTIFICATION_PID}
            </span>
            <Button
              size="small"
              color="primary"
              variant="outlined"
              startIcon={
                downloadAllDocumentsLoading ? (
                  <CircularProgress size={14} color="inherit" />
                ) : (
                  <FontAwesomeIcon icon={faDownload} size="sm" />
                )
              }
              onClick={handleDownloadAllCertificateDocuments}
              disabled={
                certificateDocumentsLoading ||
                downloadAllDocumentsLoading ||
                (certificateDocuments.length === 0 &&
                  (selectedApplicantsByCert[currentCertForDocumentList?.CERTIFICATION_PID] || []).length === 0)
              }
            >
              Download All
            </Button>
          </div>
        </ModalHeader>
        <ModalBody>
          <Paper
            sx={{ maxHeight: 400, overflow: "auto", position: "relative" }}
          >
            {certificateDocumentsLoading && (
              <Box
                sx={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  backgroundColor: "rgba(255, 255, 255, 0.7)",
                  zIndex: 1,
                }}
              >
                <CircularProgress />
              </Box>
            )}
            <List>
              {(selectedApplicantsByCert[currentCertForDocumentList?.CERTIFICATION_PID] || []).map((applicant, index) => (
                <ListItem
                  key={`application-${applicant.APPLICATION_ID ?? index}`}
                  secondaryAction={
                    <Box sx={{ display: "flex", gap: "8px" }}>
                      <Button
                        size="small"
                        variant="outlined"
                        title="View Application"
                        startIcon={<FontAwesomeIcon icon={faEye} size="sm" />}
                        onClick={() => handleViewApplicationDocument(applicant)}
                      >
                        View Application
                      </Button>
                      <Button
                        size="small"
                        variant="outlined"
                        title="Download Application"
                        startIcon={<FontAwesomeIcon icon={faDownload} size="sm" />}
                        onClick={() => handleDownloadApplication(applicant)}
                        disabled={Boolean(downloadingApplicationKey)}
                      >
                        {downloadingApplicationKey === (applicant.APPLICATION_ID ?? applicant.APPLICANT_NAME)
                          ? "Downloading..."
                          : "Download"}
                      </Button>
                    </Box>
                  }
                  sx={{ pr: "220px" }}
                >
                  <ListItemText primary={`Application - ${applicant.APPLICANT_NAME || "N/A"}`} />
                </ListItem>
              ))}
              {certificateDocuments.length > 0 ? (
                certificateDocuments.map((doc) => (
                  <ListItem
                    key={doc.ID}
                    secondaryAction={
                      <Box sx={{ display: "flex", gap: "8px" }}>
                        <Button
                          size="small"
                          variant="outlined"
                          title="View Document"
                          startIcon={<FontAwesomeIcon icon={faEye} size="sm" />}
                          onClick={() => handleViewDocument(doc)}
                        >
                          View Document
                        </Button>
                        <Button
                          size="small"
                          variant="outlined"
                          title="Download Document"
                          startIcon={<FontAwesomeIcon icon={faDownload} size="sm" />}
                          onClick={() => handleDownloadCertificateDocument(doc)}
                          disabled={Boolean(downloadingCertificateDocumentMap[doc.ID ?? doc.DocumentURL])}
                        >
                          {downloadingCertificateDocumentMap[doc.ID ?? doc.DocumentURL] ? "Downloading..." : "Download"}
                        </Button>
                      </Box>
                    }
                    sx={{ pr: "220px" }}
                  >
                    <ListItemText
                      primary={doc.DocumentName}
                      secondary={doc.Remarks}
                    />
                  </ListItem>
                ))
              ) : (selectedApplicantsByCert[currentCertForDocumentList?.CERTIFICATION_PID] || []).length === 0 ? (
                <ListItem>
                  <ListItemText primary="No documents have been uploaded yet." />
                </ListItem>
              ) : null}
            </List>
          </Paper>
        </ModalBody>
        <ModalFooter>
          <Button
            color="secondary"
            onClick={() => toggleDocumentListModal()}
          >
            Close
          </Button>
        </ModalFooter>
      </Modal >

      {/* Application PDF Modal - shows the selected applicant's Application
          (ApplicationPdfPage) from the Completed Certification Packet Documents
          modal above, same pattern as CertificatePrepare.jsx. */}
      <Modal
        size="xl"
        isOpen={Boolean(applicationPdfApplicant)}
        toggle={() => setApplicationPdfApplicant(null)}
      >
        <ModalHeader
          toggle={() => setApplicationPdfApplicant(null)}
          close={
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <Button
                variant="outlined"
                size="small"
                startIcon={applicationPdfDownloading ? <CircularProgress size={14} color="inherit" /> : <FontAwesomeIcon icon={faDownload} size="sm" />}
                onClick={() => applicationPdfPageRef.current?.download()}
                disabled={applicationPdfDownloading}
              >
                {applicationPdfDownloading ? "Downloading..." : "Download"}
              </Button>
              <button type="button" className="btn-close" aria-label="Close" onClick={() => setApplicationPdfApplicant(null)} />
            </Box>
          }
        >
          Application - {applicationPdfApplicant?.APPLICANT_NAME}
        </ModalHeader>
        <ModalBody style={{ maxHeight: "80vh", overflowY: "auto" }}>
          {applicationPdfApplicant && (
            <ApplicationPdfPage
              ref={applicationPdfPageRef}
              onDownloadingChange={setApplicationPdfDownloading}
              applicationId={applicationPdfApplicant?.APPLICATION_ID?.trim?.() || applicationPdfApplicant?.APPLICATION_ID}
              announcementId={
                applicationPdfApplicant?.ANNOUNCEMENT_ID?.trim?.() ||
                applicationPdfApplicant?.ANNOUNCEMENT_ID ||
                currentCertForDocumentList?.ANNOUNCEMENT_ID
              }
            />
          )}
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={() => setApplicationPdfApplicant(null)}>
            Close
          </Button>
        </ModalFooter>
      </Modal>

      {/* Off-screen source for the Application row's own "Download" button in the
          Completed Certification Packet Documents modal, so it can download without
          first opening the View Application modal. */}
      <div style={{ position: "absolute", left: "-9999px", top: 0, width: "816px" }}>
        {applicationDownloadTarget && (
          <ApplicationPdfPage
            key={applicationDownloadTarget.APPLICATION_ID ?? applicationDownloadTarget.APPLICANT_NAME}
            ref={applicationDownloadRef}
            onReady={handleApplicationDownloadReady}
            applicationId={
              applicationDownloadTarget?.APPLICATION_ID?.trim?.() || applicationDownloadTarget?.APPLICATION_ID
            }
            announcementId={
              applicationDownloadTarget?.ANNOUNCEMENT_ID?.trim?.() ||
              applicationDownloadTarget?.ANNOUNCEMENT_ID ||
              currentCertForDocumentList?.ANNOUNCEMENT_ID
            }
          />
        )}
      </div>

      {/* Off-screen source for "Download All" to bundle each selected applicant's
          Application PDF into the same zip as the other documents -- separate
          instance/ref from applicationDownloadTarget above. */}
      <div style={{ position: "absolute", left: "-9999px", top: 0, width: "816px" }}>
        {zipCaptureTarget && (
          <ApplicationPdfPage
            key={zipCaptureTarget.APPLICATION_ID ?? zipCaptureTarget.APPLICANT_NAME}
            ref={zipCaptureRef}
            onReady={handleZipCaptureReady}
            applicationId={zipCaptureTarget?.APPLICATION_ID?.trim?.() || zipCaptureTarget?.APPLICATION_ID}
            announcementId={
              zipCaptureTarget?.ANNOUNCEMENT_ID?.trim?.() ||
              zipCaptureTarget?.ANNOUNCEMENT_ID ||
              currentCertForDocumentList?.ANNOUNCEMENT_ID
            }
          />
        )}
      </div>

      {/* Document Preview Modal - shown in-page for a document picked from the
          Certificate Package Documents list, no new tab */}
      < Modal
        size="xl"
        isOpen={documentPreviewOpen}
        toggle={handleCloseDocumentPreview}
      >
        <ModalHeader toggle={handleCloseDocumentPreview}>
          {documentPreviewTitle || "Document"}
        </ModalHeader>
        <ModalBody style={{ height: "75vh", padding: 0 }}>
          {documentPreviewUrl && (
            <iframe
              src={documentPreviewUrl}
              title={documentPreviewTitle || "Document"}
              style={{ width: "100%", height: "100%", border: "none" }}
            />
          )}
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={handleCloseDocumentPreview}>
            Close
          </Button>
        </ModalFooter>
      </Modal >
    </>
  );
}

export default ViewCertification
